/* tslint:disable */
var TBuildGroup = (function () {
    var buildView = function (groupName, odds) {
        var groupRate = Odds.format(odds);
        return `
            <div class="betSlip-group-rate">
                <div class="betSlip-group">${$dict.bs("GroupOdds")} ${groupName}</div>
                <div id="gsce_${groupName}" class="betSlip-summary-return">
                    <span class="betSlip-summary-return-txt">${$dict.bs("TotalOdds")}</span>
                    <span id="betSlip-group-sum_${groupName}" class="betSlip-group-sum" data-uat="bet-slip-group-odds-${groupName}">${groupRate}</span>
                </div>
            </div>
        `;
    },

        buildHeader = function (groupName) {
            return `<div class="betSlip-heading-combi heading" data-uat="bet-slip-group-header">${$dict.bs("CombinatorGroup")} ${groupName}</div>`;
        };

    return {
        buildView: buildView,
        buildHeader: buildHeader
    };
}());

window.TBuildGroup = TBuildGroup;